export class FeaturesModel {
  featureGroup: string;
  featureDescription: string[];

  // Default constructor will be called by mapper
  constructor() {
    this.featureGroup = undefined;
    this.featureDescription = undefined;
  }
}
